import { render } from "./ContactUs.vue?vue&type=template&id=7368bd6b&scoped=true"
import script from "./ContactUs.vue?vue&type=script&lang=js"
export * from "./ContactUs.vue?vue&type=script&lang=js"

import "./ContactUs.vue?vue&type=style&index=0&id=7368bd6b&scoped=true&lang=css"

import exportComponent from "/workspace/wum/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7368bd6b"]])

export default __exports__